import React, { useId } from "react";

// Geometric monogram: the "L" is a fluted pillar resting on a balance beam, weighed against a gold gem on a fulcrum.
export function LogoMark({ className = "w-8 h-8", title = "Legalis AI" }) {
  const id = useId().replace(/:/g, "");
  return (
    <svg viewBox="0 0 64 64" className={className} role="img" aria-label={title} data-testid="logo-mark">
      <defs>
        <linearGradient id={`g${id}`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#F6E3A8" />
          <stop offset="0.45" stopColor="#D9B45A" />
          <stop offset="1" stopColor="#8E6B26" />
        </linearGradient>
        <linearGradient id={`d${id}`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#FFF1C4" />
          <stop offset="1" stopColor="#C99A3C" />
        </linearGradient>
      </defs>
      <g fill={`url(#g${id})`}>
        <rect x="8.5" y="7.5" width="17" height="3.4" rx="0.8" />
        <rect x="10.5" y="11.9" width="13" height="1.4" rx="0.5" />
        <rect x="12" y="14.4" width="10" height="31.6" />
        <rect x="8.5" y="46" width="47" height="4" rx="1" />
        <path d="M32 50 L37.2 57 H26.8 Z" />
        <rect x="23" y="57" width="18" height="1.6" rx="0.8" />
      </g>
      <g fill="#0B0A0D" opacity="0.55">
        <rect x="14.9" y="17" width="0.9" height="26.5" rx="0.45" />
        <rect x="18.2" y="17" width="0.9" height="26.5" rx="0.45" />
      </g>
      <path d="M47.5 33.5 L54 40 L47.5 46 L41 40 Z" fill={`url(#d${id})`} />
      <path d="M41 40 H54 M47.5 33.5 L45.2 40 L47.5 46 M47.5 33.5 L49.8 40 L47.5 46" stroke="#7A5A1E" strokeWidth="0.55" fill="none" opacity="0.7" />
    </svg>
  );
}

export function Logo({ className = "", markClass = "", textClass = "", showText = true }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      <LogoMark className={`w-8 h-8 shrink-0 ${markClass}`} />
      {showText && (
        <span className={`flex items-baseline gap-1.5 leading-none ${textClass}`}>
          <span className="font-heading text-[15px] font-extrabold tracking-[0.2em]">LEGALIS</span>
          <span className="font-mono text-[10px] font-semibold tracking-[0.18em] text-brand border-l border-brand/40 pl-1.5">AI</span>
        </span>
      )}
    </div>
  );
}
